import http from "./httpService";

const apiEndpoint = "incidentTypes";

export function getAllIncidentTypes() {
  return http.get(apiEndpoint);
}
